// removed by extract-text-webpack-plugin
module.exports = {"SpeedOrder":"SpeedOrder","DataSection":"DataSection","ContentData":"ContentData","SummaryRow":"SummaryRow","RowReverse":"RowReverse","RowButton":"RowButton","SummaryLabel":"SummaryLabel"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/SpeedOrder/SummaryRow/styles.scss
// module id = 812
// module chunks = 10